export const FETCH_GDMS_UPDATE_STATUS = 'FETCH_API_CREDENTIALS_LIST_STATUS'
